import { EntityError, ReplenishmentErrorCodes } from "@deliverr/replenishment-client";

export const extractEntityErrors = (errors: any): EntityError[] => {
  if (Array.isArray(errors)) {
    return errors;
  }

  if (errors) {
    return [errors];
  }

  return [
    {
      code: ReplenishmentErrorCodes.UNKNOWN_ERROR,
      message: "An unknown error occurred.",
      name: ReplenishmentErrorCodes.UNKNOWN_ERROR,
    },
  ];
};
